import { Checklist } from "@/bryntum-lib/models/Checklist";
import { DialogClose } from "@/modern/components/ui/dialog";
import { SharedModalBody, SharedModal, SharedModalHeader, SharedModalTitle } from "@/modern/components/shared-modal-component";
import { ChecklistMoreMenu } from "@/react/components/entityViews/checklist/components/ChecklistMoreMenu";
import ChecklistDetailLarge from "@/react/components/entityViews/checklist/components/ChecklistDetailLarge";
import { useCallback, useRef } from "react";
import { ChecklistProgressBar } from "@/react/components/entityViews/checklist/components/ChecklistProgressBar";
import { ChecklistAssignedUsers } from "@/react/components/entityViews/checklist/components/ChecklistAssignedUsers";
import { ChecklistStats } from "@/react/components/entityViews/checklist/components/ChecklistStats";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";

interface ChecklistDetailModalProps {
  checklist: Checklist | null;
  onClose?: () => void;
}

export const ChecklistDetailModal = ({ checklist, onClose }: ChecklistDetailModalProps) => {
  const closeRef = useRef<HTMLButtonElement>(null);

  const handleChecklistMoreMenuComplete = useCallback(() => {
    closeRef.current?.click();
    onClose?.();
  }, [onClose]);

  if (!checklist) return null;

  return (
    <SharedModal className="md:max-w-2xl">
      <DialogClose ref={closeRef} className="hidden" />
      <ChecklistDetailModalHeaderAndBody checklist={checklist} onFinish={handleChecklistMoreMenuComplete} />
    </SharedModal>
  );
};

export const ChecklistDetailModalHeaderAndBody = ({ checklist, onFinish }: { checklist: Checklist; onFinish?: () => void }) => {
  return (
    <>
      <SharedModalHeader>
        <ChecklistDetailModalHeader checklist={checklist} onFinish={onFinish} />
      </SharedModalHeader>
      <SharedModalBody>
        <ChecklistDetailLarge checklist={checklist} />
      </SharedModalBody>
    </>
  );
};

export const ChecklistDetailModalHeader = ({ checklist, onFinish }: { checklist: Checklist; onFinish?: () => void }) => {
  return (
    <div className="flex flex-col  pr-3">
      <div className="flex justify-between items-center flex-1 gap-2">
        <SharedModalTitle className="flex-1 min-w-0">
          <Tooltip>
            <TooltipTrigger asChild>
              <h3 className="truncate">{checklist?.title} checklist</h3>
            </TooltipTrigger>
            <TooltipContent>{checklist?.title}</TooltipContent>
          </Tooltip>
        </SharedModalTitle>
        <div className="flex items-center gap-2 flex-shrink-0">
          <ChecklistStats imageItemsCount={checklist.imageItemsCount} commentItemsCount={checklist.commentItemsCount} nudgeDate={checklist.nudgeDate} />
          <ChecklistAssignedUsers assignedBoardUsers={checklist.assignedBoardUsers} />
          {checklist && <ChecklistMoreMenu onFinish={onFinish} toggleEditChecklistName={() => {}} checklist={checklist} takeMenuItems={[0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]} />}
        </div>
      </div>
      <ChecklistProgressBar checklistId={checklist.id} />
    </div>
  );
};
